import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRadioChecked(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
